import { Box } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { ErrorMessage, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import * as Yup from 'yup';

import {
  getNoheadersStatus,
  getTableHeader,
  handleActionStepNext,
  setColumnNumericValueoofRowsIndicatorType,
  setSelectedAreas,
} from 'redux/DataImportSlice';

import ActionStepFooter from '../../ActionStepFooter';
import { FieldError, FieldLabel, StepFooterRow, StepHeading, StepSelect } from '../../actionStepUi';

interface Properties {
  getFormValue: any;
}
const validationSchema = Yup.object().shape({
  columnNumericValueoofRowsIndicatorType: Yup.string().required('Time value is required'),
});

const RowTypeSecondStep = ({ getFormValue }: Properties) => {
  const dispatch: any = useDispatch();
  const headerNames = useSelector(getTableHeader);
  const isHeader = useSelector(getNoheadersStatus);
  const [customHeaders, setCustomHeaders] = useState<any[]>(headerNames ?? []);
  useEffect(() => {
    if (isHeader) {
      const array: string[] = new Array(26)
        .fill(1)
        .map((_: string, index: number) => String.fromCodePoint(65 + index));
      const newHeaders = array
        .slice(0, headerNames.length)
        .map((item: string, headerIndex: number) => {
          return { current: `${headerNames[headerIndex]}`, modified: `Column ${item}` };
        });
      setCustomHeaders(newHeaders);
    } else {
      setCustomHeaders(
        headerNames.map((item: string) => {
          return { current: `${item}`, modified: `${item}` };
        }),
      );
    }
  }, [isHeader, headerNames]);

  const handleSubmit = (form: any, setSubmitting: (data: boolean) => void) => {
    dispatch(setColumnNumericValueoofRowsIndicatorType(form)).then(() => {
      setSubmitting(false);
      dispatch(handleActionStepNext());
    });
  };

  return (
    <Box w='100%'>
      <StepHeading
        title='Select indicator values'
        subtitle='Now select the column in your table that contains the numerical values you want to import.'
      />
      <Formik
        initialValues={{
          columnNumericValueoofRowsIndicatorType:
            getFormValue?.columnNumericValueoofRowsIndicatorType || '',
        }}
        validationSchema={validationSchema}
        onSubmit={(form, { setSubmitting }) => handleSubmit(form, setSubmitting)}
        enableReinitialize={true}
      >
        {({ values, setFieldValue, isSubmitting, errors }: any) => (
          <Form style={{ width: '100%' }}>
            <FieldLabel>Value column</FieldLabel>
            <StepSelect
              value={values?.columnNumericValueoofRowsIndicatorType}
              placeholder='Select…'
              isClearable
              isInvalid={Boolean(errors.columnNumericValueoofRowsIndicatorType)}
              options={customHeaders.map((header: any) => ({
                value: header.current,
                label: header.modified,
              }))}
              onChange={async (role) => {
                await setFieldValue('columnNumericValueoofRowsIndicatorType', role);
                await dispatch(setSelectedAreas({ selectedColumnOption: role }));
              }}
            />
            <ErrorMessage name='columnNumericValueoofRowsIndicatorType' component={FieldError} />

            <StepFooterRow>
              <ActionStepFooter
                nextButtonName='Continue'
                prevButtonName='Previous'
                isSubmitting={isSubmitting}
              />
            </StepFooterRow>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default RowTypeSecondStep;
